const LEET_MAP = {
    a: "[a@4]",
    i: "[i1!|]",
    o: "[o0]",
    e: "[e3]",
    s: "[s5$]",
    t: "[t7]",
};

export const DEFAULT_PROFANITY_WORDS = [
    "fuck",
    "shit",
    "bitch",
    "bastard",
    "asshole",
    "dickhead",
    "motherfucker",
    "cunt",
    "cock",
    "douchebag",
    "prick",
    "slut",
    "whore",
    "wanker",
    "bollocks",
    "piss",
    "twat",
    "jackass",
    "dipshit",
    "goddamn",
];

const GENERIC_REASON = "This comment contains language that isn't allowed. Please revise and try again.";

const escapeChar = (ch) => ch.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const charClass = (ch) => {
    if (Object.prototype.hasOwnProperty.call(LEET_MAP, ch)) return LEET_MAP[ch];
    return escapeChar(ch);
};

const buildPattern = (word) => {
    const body = String(word)
        .toLowerCase()
        .split("")
        .map(charClass)
        .join("[\\s._\\-*+]*");
    // Boundaries reject any adjacent letter or digit (Unicode-aware) so the blocked word must
    // stand alone — prevents matching inside "class", "Scunthorpe", "ass123", "assüber", etc.
    return new RegExp(`(?<![\\p{L}\\p{N}])${body}(?![\\p{L}\\p{N}])`, "iu");
};

const collect = (node, out) => {
    if (!node || typeof node !== "object") return;
    if (node.type === "text" && typeof node.text === "string") out.push(node.text);
    if (Array.isArray(node.children)) {
        for (const child of node.children) collect(child, out);
    }
};

export const extractPlainText = (lexicalJsonString) => {
    if (lexicalJsonString == null) return "";
    if (typeof lexicalJsonString !== "string") {
        const out = [];
        collect(lexicalJsonString.root || lexicalJsonString, out);
        return out.join(" ");
    }
    try {
        const parsed = JSON.parse(lexicalJsonString);
        const out = [];
        collect(parsed.root || parsed, out);
        return out.join(" ");
    } catch {
        return lexicalJsonString;
    }
};

export const findProfanity = (text, words) => {
    if (!text || !Array.isArray(words) || words.length === 0) return null;
    const lower = String(text).toLowerCase();
    for (const word of words) {
        if (!word) continue;
        if (buildPattern(word).test(lower)) return word;
    }
    return null;
};

export const runContentFilter = (text, config) => {
    if (!config || !config.enabled) return { blocked: false };
    if (config.profanity && config.profanity.enabled && findProfanity(text, config.profanity.words) !== null) {
        return { blocked: true, reason: GENERIC_REASON };
    }
    return { blocked: false };
};
